export default {"src":"/_next/static/media/arrow-down.e043b6f2.svg","height":15,"width":19};